import script from "./ThemeSwitchBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemeSwitchBtn.vue?vue&type=script&setup=true&lang=js"

import "./ThemeSwitchBtn.vue?vue&type=style&index=0&id=d647244c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d647244c"]])

export default __exports__